import AtomModalWithForm from '@/components/Atoms/AtomModalWithForm/AtomModalWithForm'
import type {
  AntdTreeType,
  CategoryInterface,
  NomenclatureGroupInterface,
} from '@/types'

import TreeEntityCreationFormFields from './TreeEntityCreationFormFields/TreeEntityCreationFormFields'
import useTreeEntityCreationForm, {
  type TreeEntityCreatedResult,
} from './useTreeEntityCreationForm'

type TreeEntityCreationModalPropsType = {
  open: boolean
  treeType: 'categories' | 'nomenclature-groups'
  setOpen: (open: boolean) => void
  allowUnapprovedSelection?: boolean
  defaultParentId?: string
  externalTree?: CategoryInterface[] | NomenclatureGroupInterface[]
  setExternalAntdTree?: (externalAntdTree: AntdTreeType[]) => void
  setExternalTree?:
    | ((externalTree: CategoryInterface[]) => void)
    | ((externalTree: NomenclatureGroupInterface[]) => void)
  onSuccess?: (created?: TreeEntityCreatedResult) => void
}

function TreeEntityCreationModal(props: TreeEntityCreationModalPropsType) {
  const {
    open,
    treeType,
    allowUnapprovedSelection,
    defaultParentId,
    externalTree,
    setExternalAntdTree,
    setExternalTree,
    setOpen,
    onSuccess,
  } = props

  const form = useTreeEntityCreationForm({
    active: open,
    treeType,
    allowUnapprovedSelection,
    defaultParentId,
    externalTree,
    setExternalAntdTree,
    setExternalTree,
    onSuccess: (created) => {
      setOpen(false)
      onSuccess?.(created)
    },
  })

  const handleCancel = () => {
    form.cancel()
    setOpen(false)
  }

  return (
    <>
      {form.contextHolder}
      <AtomModalWithForm
        open={open}
        submitting={form.confirmLoading}
        title={
          treeType === 'categories'
            ? 'Новая категория'
            : 'Новая группа номенклатуры'
        }
        onCancel={handleCancel}
        onSubmit={(event) => {
          event.preventDefault()
          void form.submit()
        }}
      >
        <TreeEntityCreationFormFields treeType={treeType} form={form} />
      </AtomModalWithForm>
    </>
  )
}

export default TreeEntityCreationModal
